import { Record } from 'immutable';
export class OpeningHours extends Record({
    day: 0,
    fromHour: 0,
    fromMinute: 0,
    open: false,
    toHour: 0,
    toMinute: 0,
}) {
}
export class Institution extends Record({
    image: '',
    institutionId: '',
    showPickupUntilExactClosingTime: false,
    timezone: '',
    title: '',
    usePincodeCheckin: false,
}) {
}
export class ChildRelation extends Record({
    image: '',
    name: '',
    relationId: '',
}) {
}
